// Vacancies
fetch('vacancies.json')
    .then(function (resp) {
        return resp.json();
    })
    .then(function (data) {
        let res = data.vacancies;
        if (res) {
            let temp = '';
            res.forEach((item, index) => {
                temp +=
                    '<li class="careers__item" data-number="' + index + '">' +
                    '<div class="item__header anim__line" data-number="' + index + '">' +
                    '<h2 class="item__title">' + item.title + '</h2>' +
                    '<button class="item__trigger">' +
                    '<svg width="19" height="18" viewBox="0 0 19 18" fill="none"' +
                    ' xmlns="http://www.w3.org/2000/svg">' +
                    ' <path d="M18.0178 3.18182H14.6997L14.7224 12.3068L2.6883 0.261364L0.290568 2.65909L12.3247 14.7045H3.1883L3.21102 18H18.0178V3.18182Z"' +
                    '  fill="#131313"/></svg></button></div>' +
                    '<div class="item__body">' +
                    '<h3>About the company:</h3>' +
                    '<p>' + item.aboutCompany + '</p>' +
                    '<p>' + item.secondParagraph + '</p>' +
                    '<h3>' + `${checkIfListExists('skills', item.skills)}` + '</h3>' +
                    '<ul>' + `${generateListItem(item.skills)}` + '</ul>' +
                    '<h3>' + `${checkIfListExists('niceToHave', item.niceToHave)}` + '</h3>' +
                    '<ul>' + `${generateListItem(item.niceToHave)}` + '</ul>' +
                    '<h3>' + `${checkIfListExists('areasResponsibility', item.areasResponsibility)}` + '</h3>' +
                    '<ul>' + `${generateListItem(item.areasResponsibility)}` + '</ul>' +
                    '<h3>' + `${checkIfListExists('weOffer', item.weOffer)}` + '</h3>' +
                    '<ul>' + `${generateListItem(item.weOffer)}` + '</ul>';
            })

            function checkIfListExists(arrName, arr) {
                if (arrName === 'skills' && arr.length) {
                    return 'Required skills:'
                } else if (arrName === 'niceToHave' && arr.length) {
                    return 'Nice to have:'
                } else if (arrName === 'areasResponsibility' && arr.length) {
                    return 'Areas of responsibility:'
                } else if (arrName === 'weOffer' && arr.length) {
                    return 'We offer:'
                } else {
                    return ''
                }
            }

            document.getElementById('data').innerHTML = temp;

            setTimeout(addInViewClass, 500);

            function generateListItem(arr) {
                let listItems = '';
                arr.forEach(arrItem => {
                    listItems += '<li>' + arrItem.title + '</li>';
                });
                return listItems;
            }

            // Click vac functionality
            let _items = document.querySelectorAll('.careers__item')
            let _triggers = document.querySelectorAll('.item__header')

            for (let trigger of _triggers) {
                trigger.addEventListener('click', evt => {
                    _items.forEach(item => {
                        if (item.getAttribute('data-number') === trigger.getAttribute('data-number')) {
                            item.classList.toggle('active')
                            window.scrollTo(0, item.scrollTop + 250)
                        } else {
                            item.classList.remove('active')
                        }
                    })
                })
            }
        }
    });

